module.exports = __webpack_public_path__ + "media/images/products/icook-desktop-illustration-419f3f82a89b50caffb343385958d1ef.svg";